import { db } from "@/firebase/init";
export default {
    computed:{
        userUId() {
            return this.$store.getters.getUID;
        },
    },
    methods: {
        async updateTwoFAVerified(value){
            console.log(value);
            if(this.userUId) {
                await db
                    .collection("users")
                    .doc(this.userUId)
                    .update({
                        twoFAVerified:value,
                        updatedAt: Date.now()
                    })
            }
        },
        async getTwoFAVerified() {
            if(this.userUId){
                const doc = await db.collection("users").doc(this.userUId).get();
                let twoFA = doc.data().twoFA;
                let twoFAVerified = doc.data().twoFAVerified;
                return !(twoFA && (twoFAVerified === undefined || !twoFAVerified));
            }
        }

    }
}
